




















































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";

@Component({
  name: "Contact"
})
export default class Contact extends Vue {
  private readonly nameRegex = /[^a-zA-Z.\s]/;
  private readonly emailRegex = /^[a-zA-Z0-9.+-]+@[a-zA-Z0-9.+-]+\.[a-zA-Z]{2,4}$/;
  private readonly subjectRegex = /^[a-zA-Z0-9.,?!@#$%^&*'()=_+[\]{}\- ]+$/;
  private readonly messageRegex = /[<>`]/;

  private fname = "";
  private lname = "";
  private email = "";
  private subject = "";
  private message = "";

  private validatedOnce = false;
  private validFirst = false;
  private validLast = false;
  private validEmail = false;
  private validSubject = false;
  private validMessage = false;

  private hideForm = false;
  private removeForm = false;

  onSubmit() {
    if (this.validateForm()) {
      const body = {
        fname: this.fname,
        lname: this.lname,
        email: this.email,
        subject: this.subject,
        message: this.message,
        to: "ajgiertych1@gmail.com"
      };
      this.hideForm = true;
      axios
        .post(
          "https://us-central1-aj-giertych-website.cloudfunctions.net/sendMail",
          body
        )
        .then(() => {
          this.hideForm = false;
          this.removeForm = true;
        })
        .catch(error => {
          this.hideForm = false;
          console.log(error);
        });
    }
  }

  validateForm() {
    this.validatedOnce = true;
    this.validateFirst();
    this.validateLast();
    this.validateEmail();
    this.validateSubject();
    this.validateMessage();

    return (
      this.validFirst &&
      this.validLast &&
      this.validEmail &&
      this.validSubject &&
      this.validMessage
    );
  }

  validateFirst() {
    this.validFirst = !!this.fname && !this.nameRegex.test(this.fname);
  }

  validateLast() {
    this.validLast = !!this.lname && !this.nameRegex.test(this.fname);
  }

  validateEmail() {
    this.validEmail = this.emailRegex.test(this.email);
  }

  validateSubject() {
    this.validSubject = this.subjectRegex.test(this.subject);
  }

  validateMessage() {
    this.validMessage = !!this.message && !this.messageRegex.test(this.message);
  }
}
